import React from 'react';

export interface InstagramProps {
  className?: string;
}

const Instagram: React.FC<InstagramProps> = ({ className }) => {
  return (
    <svg viewBox="0 0 15 14" fill="none" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 10.5C9.433 10.5 11 8.933 11 7C11 5.067 9.433 3.5 7.5 3.5C5.567 3.5 4 5.067 4 7C4 8.933 5.567 10.5 7.5 10.5ZM7.5 9.25C8.74264 9.25 9.75 8.24264 9.75 7C9.75 5.75736 8.74264 4.75 7.5 4.75C6.25736 4.75 5.25 5.75736 5.25 7C5.25 8.24264 6.25736 9.25 7.5 9.25Z"
        fill="currentColor"
      />
      <path
        d="M11.375 4C11.8582 4 12.25 3.60825 12.25 3.125C12.25 2.64175 11.8582 2.25 11.375 2.25C10.8918 2.25 10.5 2.64175 10.5 3.125C10.5 3.60825 10.8918 4 11.375 4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.935974 2.18404C0.5 3.03969 0.5 4.15979 0.5 6.4V7.6C0.5 9.84021 0.5 10.9603 0.935974 11.816C1.31947 12.5686 1.93139 13.1805 2.68404 13.564C3.53969 14 4.65979 14 6.9 14H8.1C10.3402 14 11.4603 14 12.316 13.564C13.0686 13.1805 13.6805 12.5686 14.064 11.816C14.5 10.9603 14.5 9.84021 14.5 7.6V6.4C14.5 4.15979 14.5 3.03969 14.064 2.18404C13.6805 1.43139 13.0686 0.819467 12.316 0.435974C11.4603 0 10.3402 0 8.1 0H6.9C4.65979 0 3.53969 0 2.68404 0.435974C1.93139 0.819467 1.31947 1.43139 0.935974 2.18404ZM8.1 1.25H6.9C5.75927 1.25 4.9789 1.25097 4.3746 1.30035C3.78489 1.34853 3.47376 1.4365 3.25153 1.54973C2.73408 1.81338 2.31338 2.23408 2.04973 2.75153C1.9365 2.97376 1.84853 3.28489 1.80035 3.8746C1.75097 4.4789 1.75 5.25927 1.75 6.4V7.6C1.75 8.74073 1.75097 9.5211 1.80035 10.1254C1.84853 10.7151 1.9365 11.0262 2.04973 11.2485C2.31338 11.7659 2.73408 12.1866 3.25153 12.4503C3.47376 12.5635 3.78489 12.6515 4.3746 12.6997C4.9789 12.749 5.75927 12.75 6.9 12.75H8.1C9.24073 12.75 10.0211 12.749 10.6254 12.6997C11.2151 12.6515 11.5262 12.5635 11.7485 12.4503C12.2659 12.1866 12.6866 11.7659 12.9503 11.2485C13.0635 11.0262 13.1515 10.7151 13.1997 10.1254C13.249 9.5211 13.25 8.74073 13.25 7.6V6.4C13.25 5.25927 13.249 4.4789 13.1997 3.8746C13.1515 3.28489 13.0635 2.97376 12.9503 2.75153C12.6866 2.23408 12.2659 1.81338 11.7485 1.54973C11.5262 1.4365 11.2151 1.34853 10.6254 1.30035C10.0211 1.25097 9.24073 1.25 8.1 1.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Instagram;
